// Copyright (c) Docugami, Inc. All rights reserved.**/

import { IconAlignment } from "components/cards/CommandButton";
import { DocumentNavButton, getNavigationTargetDocument, NavDirection, nextDocumentNavProps, prevDocumentNavProps } from "components/common/DocumentNavButton";
import { NavigationType, useNavigationService } from "hooks/navigationService";

interface ReportDocumentNavButtonProps {
    currentDocumentId: string;
    documentIds?: string[];
    direction: NavDirection;
}

export const ReportDocumentNavButton = ({ documentIds, currentDocumentId, direction }: ReportDocumentNavButtonProps) => {
    const navService = useNavigationService();

    if (!documentIds?.length) {
        return null;
    }

    const { label, iconName } = direction === NavDirection.Left ? prevDocumentNavProps : nextDocumentNavProps;
    const iconAlignment = direction === NavDirection.Left ? IconAlignment.Left : IconAlignment.Right;
    const navTargetDocument = !!documentIds ? getNavigationTargetDocument(currentDocumentId, documentIds, direction === NavDirection.Left, false) : undefined;

    const navToDocument = () => {
        if (!!navTargetDocument) {
            navService.navToReportPage(
                NavigationType.ReplaceCurrentPage,
                { documentId: navTargetDocument });
        }
    }

    return (
        <DocumentNavButton
            label={label}
            iconName={iconName}
            iconAlignment={iconAlignment}
            onClick={navToDocument}
            disabled={!navTargetDocument} />
    )
}